export const SET_IS_MOBILE_VIEW = 'SET_IS_MOBILE_VIEW';
export const SET_IS_TABLET_VIEW = 'SET_IS_TABLET_VIEW';
